import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useShouldShowFilterDesktop = () => {
    const location = useLocation();

    return useMemo(() => {
        return location.pathname !== '/status' && location.pathname !== '/no-access';
    }, [location.pathname]);
};
